import sharingMethod from 'src/shared/sharing_method.js'

document.addEventListener("turbolinks:load", function () {

  sharingMethod.clipboardCopy('clipboard')
  // generate qrcode and html to image
  sharingMethod.shareQrcodeImage()
  // bidTimer  timer countdown
  sharingMethod.bidTimer()
});